const ORIGINAL_CONSOLE_ERROR_SYMBOL = Symbol.for(
  "vidseeds.observability.original_console_error",
);

type ConsoleErrorFn = (...args: unknown[]) => void;

type GlobalWithConsoleState = typeof globalThis & {
  [ORIGINAL_CONSOLE_ERROR_SYMBOL]?: ConsoleErrorFn;
};

export function setOriginalConsoleError(fn: ConsoleErrorFn): void {
  const globalState = globalThis as GlobalWithConsoleState;
  if (!globalState[ORIGINAL_CONSOLE_ERROR_SYMBOL]) {
    globalState[ORIGINAL_CONSOLE_ERROR_SYMBOL] = fn;
  }
}

export function getOriginalConsoleError(): ConsoleErrorFn {
  const globalState = globalThis as GlobalWithConsoleState;
  return (
    globalState[ORIGINAL_CONSOLE_ERROR_SYMBOL] ||
    ((...args: unknown[]) => {
      console.error(...args);
    })
  );
}
